import { Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useHttp } from "~hooks/useHttp.js";
import StandingsAdjustmentsForm from "./StandingsAdjustmentsForm";
import { useNotification } from "~hooks/useNotification";

const AddStandingsAdjustmentsModal = ({ handleCloseModal, openModal, handleSendRequest, okButtonLoading }) => {
  const { formatMessage } = useIntl();
  const { sport, organizationId, seasonId } = useParams();
  const [formRef, setFormRef] = useState(null);
  const [entityList, setEntityList] = useState(null);

  const handleSetFormRef = (form) => setFormRef(form);

  const {
    error: fetchEntitiesError,
    request: fetchEntitiesRequest,
    cleanError: fetchEntitiesCleanError,
  } = useHttp();
  const notification = useNotification();

  const fetchEntities = useCallback(async () => {
    try {
      const res = await fetchEntitiesRequest({
        url: `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/entities?include=organization,entities,seasons&limit=1000`,
      });

      let combineResourceData = [];
      if (res?.data && res?.includes?.resources?.entities) {
        combineResourceData = res?.data || [];
        combineResourceData.forEach((result, index) => {
          combineResourceData[index] = {
            ...result,
            ...res.includes.resources.entities[result.entity.id],
          };
        });
      }

      setEntityList(combineResourceData);
    } catch (e) {
      console.error(e);
    }
  }, [fetchEntitiesRequest, sport, organizationId, seasonId]);

  useEffect(() => {
    if (fetchEntitiesError) {
      notification.error({
        message: "Unable to fetch teams",
        description: fetchEntitiesError,
        placement: "bottomRight",
      });
      fetchEntitiesCleanError();
    }
  }, [fetchEntitiesError, fetchEntitiesCleanError]);


  useEffect(() => {
    fetchEntities();
  }, [fetchEntities]);

  return (
    <Modal
      width={750}
      open={openModal}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      title={formatMessage({
        id: "standings.adjustment.add",
        defaultMessage: "Add New Standings Adjustment",
      })}
      okText={formatMessage({
        id: "standings.adjustment.create",
        defaultMessage: "Submit New Standing Adjustment",
      })}
      onOk={() => handleSendRequest(formRef)}
      okButtonProps={{ loading: okButtonLoading }}
    >
      <StandingsAdjustmentsForm handleSetFormRef={handleSetFormRef} entityList={entityList}/>
    </Modal>
  );
};

export default AddStandingsAdjustmentsModal;
